import React from "react";
import api from "../../../store/api/api";
import { UserAccount } from "../../../types/admin";
import { TextField, MenuItem, CircularProgress } from "@mui/material";

interface MfaSelectorProps {
    user: UserAccount;
}

interface MfaSelectorState {
    mfa_state: string;
    loading: boolean;
}

class MfaSelector extends React.Component<MfaSelectorProps, MfaSelectorState> {
    constructor(props: MfaSelectorProps) {
        super(props);

        const mfaEnabled = this.props.user.profile?.mfa_enabled;
        const mfaRequired = this.props.user.profile?.mfa_required;

        this.state = {
            mfa_state: mfaRequired ? `mfa_required` : mfaEnabled ? `mfa_enabled` : `disabled`,
            loading: false
        };
    }

    setMfaRule = (new_mfa_state: string) => {
        let payload = { mfa_enabled: 0, mfa_required: 0 }
        if (new_mfa_state === 'mfa_required') {
            payload.mfa_required = 1;
            payload.mfa_enabled = 1;
        } else if (new_mfa_state === 'mfa_enabled') {
            payload.mfa_enabled = 1;
            payload.mfa_required = 0;
        }

        this.setState({ loading: true });
        let promise: Promise<any>;
        if (!this.props.user.profile) {
            promise = api.post(`/profiles/?user=${this.props.user.id}`, payload)
        } else {
            const profile = this.props.user.profile;
            promise = api.patch(`/profiles/${profile.id}/`, payload)
        }
        promise.then((res) => {
            console.log(res.data);
            this.setState({ "mfa_state": new_mfa_state })
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            this.setState({ loading: false });
        });
    };

    getColor() {
        return this.state.mfa_state === 'mfa_required' ? 'rgb(211, 47, 47)' : (this.state.mfa_state === 'mfa_enabled' ? 'rgb(98, 176, 59)' : 'inherit');
    }

    render() {
        return <React.Fragment>
            <TextField
                select
                variant="standard"
                disabled={this.state.loading === true}
                size="small"
                sx={{ '& .MuiSelect-select': { color: this.getColor() } }}
                value={this.state.mfa_state}
                onChange={(e) => this.setMfaRule(e.target.value)} >
                <MenuItem value={`disabled`}>Disabled</MenuItem>
                <MenuItem sx={{ color: 'primary.main' }} value={`mfa_enabled`}>Optional</MenuItem>
                <MenuItem sx={{ color: 'error.main' }} value={`mfa_required`}>Required</MenuItem>
            </TextField>
            {this.state.loading && <CircularProgress size={16} sx={{ marginLeft: 1 }} />}
        </React.Fragment>
    }
}

export default MfaSelector; 